import { render } from "./KeyF4.vue?vue&type=template&id=a7e101fa"
import script from "./KeyF4.vue?vue&type=script&lang=ts"
export * from "./KeyF4.vue?vue&type=script&lang=ts"
script.render = render

export default script